<a [attr.href]="link" class="a00060">
    <span class="text">{{ text }}</span>
    <span
        class="arrow"
        [inlineSVG]="
            '/assets/icons/arrow/black.svg' | assetPath
        "
    ></span>
</a>
